import { useNavigate } from "react-router-dom";
import EditIcon from '@mui/icons-material/Edit';
import { Button } from "@mui/material";

const ManageProfile = () => {

  const navigate = useNavigate();

  return (
    <>
      <div className="main_title">
        <h1>Manage Profile</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Manage Profile
        </p>
      </div>

      <div className="cards view_page">
        <div className="table_header">
          <div className="left_s">
            <h2>General Details</h2>
          </div>
          <div className="right_s">
            <Button className="btn btn_primary" onClick={() => navigate("/manage-profile/edit")}><EditIcon /> Edit Profile</Button>
          </div>
        </div>
        <div className="gap_p">
          <div className="vew_img w_100">
            <h6>Image</h6>
            <figure>
              <img alt="user" src="/static/images/admin_icon.png" />
            </figure>
          </div>
          <div className="w_33">
            <h6>Name</h6>
            <p>Admin</p>
          </div>
          <div className="w_33">
            <h6>Email Id</h6>
            <p>admin@gmail.com</p>
          </div>
          <div className="w_33">
            <h6>Phone Number</h6>
            <p>9876543210</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManageProfile;
